/*
 * Product pages: keeps the sticky info column (title, price, buy buttons ...) reachable.
 * The column pins under the fixed menu bar and logo bar (120px). When it is taller than the window it could
 * never show its lower part while the photos scroll, so then it scrolls until its bottom is in view and pins
 * there. Re-measured when the window or the column changes size (an opened row, a longer variant name ...).
 */
(function () {
  'use strict';

  var PIN = 120; // fixed menu bar + logo bar, plus a little air
  var BOTTOM = 24;

  function fit() {
    var info = document.querySelector('.product__info-container.product__column-sticky');
    if (!info) return;
    if (window.innerWidth < 990) {
      info.style.top = '';
      return;
    }
    var height = info.offsetHeight;
    var room = window.innerHeight - PIN - BOTTOM;
    info.style.top = (height > room ? window.innerHeight - height - BOTTOM : PIN) + 'px';
  }

  function start() {
    var info = document.querySelector('.product__info-container.product__column-sticky');
    if (!info) return;
    fit();
    window.addEventListener('resize', fit);
    window.addEventListener('load', fit);
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(info);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
